// src/pages/KnowledgeBase/Learn.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function Learn() {
  const tutorials = [
    { title: 'Upload trades (CSV)', to: '/kb/trade-tracker#upload' },
    { title: 'View daily valuations', to: '/kb/trade-tracker#valuations' },
    { title: 'Export a report', to: '/kb/trade-tracker#reports' },
  ];

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold text-brand1">How-to tutorials</h1>
      <p className="text-app">Short walkthroughs to complete common tasks.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {tutorials.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className="block rounded-2xl border border-app bg-app text-app p-5 shadow-sm hover:shadow-md transition"
          >
            <div className="text-base font-medium text-app">{t.title}</div>
            <div className="text-xs text-muted mt-1">Step-by-step, with screenshots</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
